import React from 'react';
import NavBar from './Navbar/NavBar';

const Hero = () => {
    return (
        <div className="hero bg-gray-900 text-white min-h-screen flex flex-col" id="hero" style={{ fontFamily: "'Syne', sans-serif" }}>
            <NavBar />

            <div className="flex flex-col justify-center items-center flex-grow text-center px-6 md:px-16 lg:px-48 pb-16">
                {/* Pill badge */}
                <div className="mb-6 inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 text-sm text-gray-300 tracking-wide">
                    Making a difference, one step at a time
                </div>

                <h1 className="mb-6 text-3xl md:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight">
                    Providing new and gently used shoes<br className="hidden md:block" /> to individuals and communities in need
                </h1>

                <p className="text-lg md:text-xl font-normal text-gray-300 mb-10 leading-relaxed max-w-2xl">
                    Working together as a community, for the community
                </p>

                <a
                    href="/contact"
                    className="inline-flex items-center gap-2 text-white bg-white/15 border border-white/30 hover:bg-white hover:text-black px-8 py-4 rounded-xl text-lg font-medium shadow-lg transition-all duration-300 hover:scale-105 group"
                >
                    Get in Touch
                    <svg
                        className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                        />
                    </svg>
                </a>
            </div>

            {/* Scroll indicator */}
            <div className="flex justify-center pb-8 animate-bounce">
                <svg className="w-6 h-6 text-white/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 9l-7 7-7-7" />
                </svg>
            </div>
        </div>
    );
};

export default Hero;
